const forEach = require('lodash/forEach');

function parseSearchTradingData(data) {
  if ((!data) || data.length == 0) {
    return null;
  }
  else {
    if (data.orders) {
      let orders = [];
      forEach(data.orders, function(parsedOrder){
        const orderGroup = (parsedOrder.typeDetails && parsedOrder.typeDetails.orderGroup) || null;
        const execution = (parsedOrder.typeDetails && parsedOrder.typeDetails.execution) || null;
        const coreDetails = parsedOrder.coreDetails || null;
        const asset = parsedOrder.asset || null;
        const tradeCurrency = parsedOrder.tradeCurrency || null;
        const status = parsedOrder.status || null;
        let orderObj = parsedOrder;
        orderObj.actions = parsedOrder.actions || [];
        orderObj.typeDetails = {
          orderGroup: {
            displayText: (orderGroup && orderGroup.displayText) || null,
            type: (orderGroup && orderGroup.type) || null
          },
          execution: {
            displayText: (execution && execution.displayText) || null,
            type: (execution && execution.type) || null,
          }
        };
        orderObj.coreDetails = {
          estimatedPrice: coreDetails.estimatedPrice,
          orderedQuantity: coreDetails.orderedQuantity,
          limitPrice: coreDetails.limitPrice,
          expiryDate: coreDetails.expiryDate
        };
        orderObj.asset = {
          assetId : (asset && asset.assetId) || null,
          name : (asset && asset.name) || null,
          securityType : (asset && asset.securityType) || null,
          isin : (asset && asset.isin) || null,
          ricCode : (asset && asset.ricCode) || null,
          valoren : (asset && asset.valoren) || null,
          ticker : (asset && asset.ticker) || null,
          market : (asset && asset.market) || null,
          lastAvailablePrices : (asset && asset.lastAvailablePrices) || null,
        };
        orderObj.tradeCurrency = {
          currencyId: (tradeCurrency && tradeCurrency.currencyId) || null,
          code: (tradeCurrency && tradeCurrency.code) || null,
          name: (tradeCurrency && tradeCurrency.name) || null
        }
        orderObj.status = {
          color : (status && status.color) || null,
          displayText : (status && status.displayText) || null,
          type : (status && status.type) || null
        }
        orders.push(orderObj);
      })
      data.orders = orders;
      return JSON.stringify(data);
    }
    return null;
  }

}

function parseAssetSearchTradingData(data) {
  if ((!data) || data.length == 0) {
    return null;
  }
  else {
    if (data.assets) {
      let assets = [];
      forEach(data.assets,function(assetItem){
        const market = assetItem.market || null;
        const marketCountry =  (market && market.country) || null;
        const marketCurrency = (market && market.currency) || null;
        let assetItemObj = assetItem;
        if (assetItem.lastAvailablePrices) {
          let lastAvailablePrices = [];
          for (let j = 0; j < assetItem.lastAvailablePrices.length; j++) {
            let lastAvailablePriceItem = assetItem.lastAvailablePrices[j];
            const priceCurrency = lastAvailablePriceItem.priceCurrency || null;
            lastAvailablePriceItem.priceCurrency = {
              code : (priceCurrency && priceCurrency.code) || null,
              currencyId : (priceCurrency && priceCurrency.currencyId) || null,
              name : (priceCurrency && priceCurrency.name) || null,
            }
            lastAvailablePrices.push(lastAvailablePriceItem);
          }
          assetItemObj.lastAvailablePrices = lastAvailablePrices;
        } else {
          assetItemObj.lastAvailablePrices = [
            {
              dayChangePercentage: null,
              dayChangePrice: null,
              price: null,
              priceCurrency: {
                code: null,
                currencyId: null,
                name: null
              },
              priceDate: null
            }
          ]
        }
        assetItemObj.market = {
          code : (market && market.code) || null,
          country : {
            code: (marketCountry && marketCountry.code) || null,
            countryId: (marketCountry && marketCountry.countryId) || null,
            name: (marketCountry && marketCountry.name) || null
          },
          currency : {
            code: marketCurrency && marketCurrency.code || null,
            currencyId: marketCurrency && marketCurrency.currencyId || null,
            name: marketCurrency && marketCurrency.name || null
          },
          marketId: market && market.marketId || null,
          name: market && market.name || null
        }
        assets.push(assetItemObj);
      })
      data.assets = assets;
      return JSON.stringify(data);
    }
    return null;
  }
}

function parseAssetDetailData(data) {
  if ((!data) || data.length == 0) {
    return null;
  } else {
    if (data.asset) {
      let assetObj = data.asset;
      const market = data.asset.market || null;
      const country = (market && market.country) || null;
      const currency = (market && market.currency) || null;
      if (assetObj.lastAvailablePrices) {
        let lastAvailablePrices = [];
        forEach(assetObj.lastAvailablePrices, function(lastAvailablePriceItem){
          const priceCurrency = lastAvailablePriceItem.priceCurrency || null;
          lastAvailablePriceItem.priceCurrency = {
            code: (priceCurrency && priceCurrency.code) || null,
            currencyId: (priceCurrency && priceCurrency.currencyId) || null,
            name: (priceCurrency && priceCurrency.name) || null,
          }
          lastAvailablePrices.push(lastAvailablePriceItem);
          assetObj.lastAvailablePrices = lastAvailablePrices;
        })
      } else {
        assetObj.lastAvailablePrices = [{
          dayChangePercentage: null,
          dayChangePrice: null,
          price: null,
          priceCurrency: {
            code: null,
            currencyId: null,
            name: null
          },
          priceDate: null
        }]
      }
      assetObj.market = {
        code: (market && market.code) || null,
        country: {
          code: (country && country.code) || null,
          countryId: (country && country.countryId) || null,
          name: (country && country.name) || null,
        },
        currency: {
          code: (currency && currency.code) || null,
          currencyId: (currency && currency.currencyId) || null,
          name: (currency && currency.name) || null
        },
        marketId: (market && market.marketId) || null,
        name: (market && market.name) || null,
      }
      data.asset = assetObj;
      return JSON.stringify(data);
    }
    return null;
  }
}

function parseAssetsLookupData(data){
  if ((!data) || data.length == 0) {
    return null;
  } else {
  return JSON.stringify(data);
  }
}

function parseCancelOrder(data){
  if ((!data) || data.length == 0) {
    return null;
  } else {
  return JSON.stringify(data);
  }
}

function parseApproveOrder(data){
  if ((!data) || data.length == 0) {
    return null;
  } else {
  return JSON.stringify(data);
  }
}

function parseFetchDocuments(data){
  if ((!data) || data.length == 0) {
    return null;
  } else {
  return JSON.stringify(data);
  }
}

function serviceFactory({ api }) {
  const search = ({ inputParam, metaData }) =>
    api
      .search(inputParam, metaData)
      .then(parseSearchTradingData);

  const assetSearch = ({ inputParam, metaData }) =>
    api
      .assetSearch(inputParam, metaData)
      .then(parseAssetSearchTradingData);

  const getSingleSecurityDetail = ({ inputParam, metaData }) =>
    api
      .getSingleSecurityDetail(inputParam, metaData)
      .then(parseAssetDetailData);

 const getAssetsLookupData = ({ inputParam, metaData }) =>
    api
      .getAssetsLookupData(inputParam, metaData)
      .then(parseAssetsLookupData);

  const cancelOrder = ({ inputParam, metaData }) =>
    api
      .cancelOrder(inputParam, metaData)
      .then(parseCancelOrder);

  const approveOrder = ({ inputParam, metaData }) =>
    api
      .approveOrder(inputParam, metaData)
      .then(parseApproveOrder);

  return {
    search,
    assetSearch,
    getSingleSecurityDetail,
    getAssetsLookupData,
    cancelOrder,
    approveOrder
  }
}

module.exports = serviceFactory;
